export const PRODUCT_CREATE_REQUESTED = 'PRODUCT_CREATE_REQUESTED';
export const PRODUCT_CREATE_SUCCEEDED = 'PRODUCT_CREATE_SUCCEEDED';
export const PRODUCT_CREATE_FAILED = 'PRODUCT_CREATE_FAILED';

export const PRODUCT_UPDATE_REQUESTED = 'PRODUCT_UPDATE_REQUESTED';
export const PRODUCT_UPDATE_SUCCEEDED = 'PRODUCT_UPDATE_SUCCEEDED';
export const PRODUCT_UPDATE_FAILED = 'PRODUCT_UPDATE_FAILED';

export const PRODUCT_DELETE_REQUESTED = 'PRODUCT_DELETE_REQUESTED';
export const PRODUCT_DELETE_SUCCEEDED = 'PRODUCT_DELETE_SUCCEEDED';
export const PRODUCT_DELETE_FAILED = 'PRODUCT_DELETE_FAILED';

export const PRODUCT_SET = 'PRODUCT_SET';
export const PRODUCTS_SET = 'PRODUCTS_SET';
